module.exports = __webpack_public_path__ + "img/trash_orange.67da9042.svg";